import { FC, useContext, useEffect, useState } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import NodeHandle from '../../components/shared/Handle'
import { PlaybookContext } from '../../contexts/playbooks.context'
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags'

import styles from './styles.module.scss'

interface IProps {
  data: {
    label: string
    nodeId: number
  }
}

const StartNode: FC<IProps> = ({ data }) => {
  const theme = useTheme()

  const [isHighlighted, setIsHighlighted] = useState(false)

  const { playbook, reactFlowNodes } = useContext(PlaybookContext)

  useEffect(() => {
    const node = reactFlowNodes.find(
      (node) => node.selected && +node.id === data.nodeId,
    )

    if (node) {
      setIsHighlighted(true)
    } else {
      setIsHighlighted(false)
    }
  }, [reactFlowNodes, data.nodeId])

  const style: React.CSSProperties = {
    backgroundColor: theme.palette.elevated.main,
    border: '2px solid ' + theme.palette.elevated.dark,
  }

  if (isHighlighted) {
    Object.assign(style, {
      boxShadow: '0 0 10px ' + theme.palette.text.primary,
    })
  }

  return (
    <div
      id={`${data.nodeId}`}
      className={styles.node}
      data-testid="playbookStart"
      style={style}
    >
      <div className={styles.content}>
        <div className={styles.textContainer}>
          <Box
            className={styles.nodeIcons}
            sx={{ color: theme.palette.success.light }}
          >
            <EmojiFlagsIcon sx={{ width: 40, height: 40 }} />
          </Box>
          <Typography id="nodeIdentifier" className={styles.text}>
            START
          </Typography>
        </div>
        {playbook && (
          <NodeHandle direction={playbook.direction} isStartNode={true} />
        )}
      </div>
    </div>
  )
}

export default StartNode
